// extracted by mini-css-extract-plugin
export var component = "ModuleWrapper-module--component--KHVhg";
export var header = "ModuleWrapper-module--header--mW+8F";
export var title = "ModuleWrapper-module--title--zuC6c";